<template>
  <el-upload
    action="#"
    :auto-upload="true"
    :fileList="cloneFileList"
    :limit="limit"
    :http-request="handleUpload"
    :on-success="handleSuccess"
    :on-exceed="handleExceed"
    :accept="accept"
    :before-upload="beforeUpload"
    :on-remove="onRemove"
    :listType="listType"
  >
    <slot></slot>

    <div
      v-if="listType == 'picture-card'"
      style="height: 100%; width: 100%"
      slot="file"
      slot-scope="{ file }"
    >
      <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
      <span class="el-upload-list__item-actions">
        <span
          class="el-upload-list__item-preview"
          @click="handlePictureCardPreview(file)"
        >
          <i class="el-icon-zoom-in"></i>
        </span>
        <!-- <span class="el-upload-list__item-delete" @click="handleDownload(file)">
          <i class="el-icon-download"></i>
        </span> -->
        <span class="el-upload-list__item-delete" @click="handleRemove(file)">
          <i class="el-icon-delete"></i>
        </span>
      </span>
    </div>
  </el-upload>
</template>

<script>
import { uploadFile } from "@/api/commonApi";
import { deepCopy } from "@/utils";
export default {
  components: {},
  props: {
    accept: {
      type: String,
      default() {
        return ".jpg, .jpeg, .png, .JPG, .JPEG";
      },
    },
    beforeUpload: {
      type: Function,
      default: null,
    },
    onRemove: {
      type: Function,
      default: null,
    },
    fileList: {
      type: Array,
      default() {
        return [];
      },
    },
    limit: {
      type: Number,
      default: null,
    },
    customParam: {
      //自定义上传参数
      type: Object,
      default() {
        return {
          // source: 2,
        };
      },
    },
    listType: {
      type: String,
      validator(val) {
        return ["text", "picture", "picture-card"].indexOf(val) != -1;
      },
      default: "text",
    },
  },
  data() {
    return {
      cloneFileList: [],
    };
  },
  methods: {
    handleUpload(request) {
      let rawFile = request.file;

      let file = {
        status: "ready", //标识是否已经上传
        name: rawFile.name,
        size: rawFile.size,
        raw: rawFile,
      };
      if (rawFile.type === "image/jpeg" || rawFile.type === "image/png") {
        try {
          file.url = URL.createObjectURL(rawFile);
        } catch (err) {
          console.error("[Element Error][Upload]", err);
          return;
        }
      }
      this.cloneFileList.push(file);
      console.log(this.cloneFileList);
      console.log(file);
      const prom = new Promise((resolve, reject) => {});
      prom.abort = () => {};
      return prom;
    },

    async doUpload() {
      let fileList = this.cloneFileList;
      let promiseList = [];
      if (fileList.length > 0) {
        fileList.map((item) => {
          if (item.status == "ready") {
            //未上传的才上传
            let rawFile = item.raw;
            let formData = new FormData();
            formData.append("file", rawFile);
            // formData.append("source", 2);
            if (this.customParam) {
              Object.keys(this.customParam).map((key) => {
                formData.append(key, this.customParam[key]);
              });
            }
            let promise = new Promise((resolve) => {
              uploadFile(formData).then((res) => {
                item.status = "finished";
                resolve(res);
              });
            });
            promiseList.push(promise);
          }
        });
      }
      return new Promise((resolve) => {
        Promise.all(promiseList).then((result) => {
          let resData = [];
          result.map((res) => {
            console.log(res);
            if (res.code === 0) {
              if (res.data) {
                let fileurl = res.data.fileurl_2 || res.data.fileurl;
                resData.push(fileurl);
              }
            }
          });
          resolve(resData);
        });
      });
    },
    handleSuccess() {},
    handleExceed() {
      this.$message({
        type: "warning",
        message: "超出文件数量上限!",
      });
    },
    //图片预览
    handlePictureCardPreview(file) {
      console.log(file);
      let url = file.url;
      let images = [url];
      this.$viewerApi({
        images: images,
      });
    },
    handleRemove(file) {
      console.log(file);
      if (typeof this.onRemove == "function") {
        this.cloneFileList = this.cloneFileList.filter(
          (item) => item.id != file.id
        );
        this.onRemove(file);
      }
    },
  },
  watch: {
    fileList(val) {
      if (Array.isArray(val)) {
        let list = deepCopy(val);
        list.map((item) => {
          item.status = "finished";
        });
        this.cloneFileList = list;
      } else {
        this.cloneFileList = [];
      }
    },
  },
};
</script>

<style scoped lang="scss">
</style>
